__turbopack_context__.v({
  "buttonGroup": "ProductStripDeals-module-scss-module__okWVvq__buttonGroup",
  "container": "ProductStripDeals-module-scss-module__okWVvq__container",
  "header": "ProductStripDeals-module-scss-module__okWVvq__header",
  "heading": "ProductStripDeals-module-scss-module__okWVvq__heading",
  "navButton": "ProductStripDeals-module-scss-module__okWVvq__navButton",
  "root": "ProductStripDeals-module-scss-module__okWVvq__root",
  "slide": "ProductStripDeals-module-scss-module__okWVvq__slide",
  "swiper": "ProductStripDeals-module-scss-module__okWVvq__swiper",
});
